import styled from "styled-components/native";

export default styled.View`
  background: #e7eaec;
  height: 1px;
  width: 100%;
`;
